import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const fetchPartnerData = async (partnerId: string): Promise<IWWPartners | null> => {
  const crud = CrudStore.get(CrudStoreItem.WW_Partners, 'fetchPartnerData')
  crud.setDefaultFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerID',
        operator: Operator.EQUAL,
        value: partnerId,
      },
    ],
  })
  const res = await crud.fetch()
  return res.items[0]
}
